import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppointmentService} from "../../../../service/api/appointment.service";
import {AppointmentDto} from "../../../../model/dto/entity/appointment.dto";
import {AgentDto} from "../../../../../../feature-core/am/model/dto/entity/agent.dto";
import {CustomerContactDto} from "../../../../../cr/model/dto/entity/customer-contact.dto";
import {TicketDto} from "../../../../../../feature-core/tm/model/dto/entity/ticket.dto";
import {AppointmentTypeDto} from "../../../../model/dto/entity/appointment-type.dto";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";
import {MsCalendarEventDto} from "../../../../../../feature-core/am/model/dto/api/ms/ms-calendar.types";

@Component({
    selector: 'as-appointment-reschedule-appointment',
    templateUrl: 'as-appointment-reschedule-appointment.component.html',
    standalone: false
})
export class AsAppointmentRescheduleAppointmentComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() appointment: AppointmentDto;
    @Input() agent: AgentDto;
    @Input() name: string;
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() customerContactDto: CustomerContactDto[];
    @Input() appointmentType: AppointmentTypeDto;
    @Input() ticket: TicketDto;
    @Input() newAgent: boolean;
    @Input() addressId: number;
    @Output() onAppointmentUpdate: EventEmitter<MsCalendarEventDto> = new EventEmitter();


    constructor(protected appointmentService: AppointmentService) {
    }

    ngOnInit(): void {
        console.log(JSON.stringify(this.appointment));
        console.log(JSON.stringify(this.agent));
        console.log(JSON.stringify(this.name));
        console.log(JSON.stringify(this.objectIdentifier));
        console.log(JSON.stringify(this.customerContactDto));
        console.log(JSON.stringify(this.appointmentType));
        console.log(JSON.stringify(this.ticket));
        console.log(JSON.stringify(this.newAgent));
        console.log(JSON.stringify(this.addressId));
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    handleAppointmentUpdate(event: MsCalendarEventDto) {
        this.onAppointmentUpdate.emit(event);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
